// Normatives
export const NORMATIVE = '/normative';
export const GET_NORMATIVES = '/normative/';
export const DELETE_NORMATIVE = '/normative';
export const ADD_NORMATIVE = '/normative/';
export const UPDATE_NORMATIVE = '/normative';

// Normative entitys
export const NORMATIVE_ENTITY = '/normative_entity';
export const GET_NORMATIVE_ENTITYS = '/normative_entity/';
export const DELETE_NORMATIVE_ENTITY = '/normative_entity';
export const ADD_NORMATIVE_ENTITY = '/normative_entity/';
export const UPDATE_NORMATIVE_ENTITY = '/normative_entity';

// Normative categories
export const NORMATIVE_CATEGORY = '/normative_category';
export const GET_NORMATIVE_CATEGORIES = '/normative_category/';
export const DELETE_NORMATIVE_CATEGORY = '/normative_category';
export const ADD_NORMATIVE_CATEGORY = '/normative_category/';
export const UPDATE_NORMATIVE_CATEGORY = '/normative_category';

// Normative status
export const NORMATIVE_STATUS = '/normative_status';
export const GET_NORMATIVE_STATUS = '/normative_status/';
export const DELETE_NORMATIVE_STATUS = '/normative_status';
export const ADD_NORMATIVE_STATUS = '/normative_status/';
export const UPDATE_NORMATIVE_STATUS = '/normative_status';

// Normative obligation
export const OBLIGATION = '/obligation';
export const GET_OBLIGATIONS = '/obligation/';
export const DELETE_OBLIGATION = '/obligation';
export const ADD_OBLIGATION = '/obligation/';
export const UPDATE_OBLIGATION = '/obligation';

// Normative obligation establishment
export const OBLIGATION_ESTABLISHMENT = '/obligation_establishment';
export const GET_OBLIGATION_ESTABLISHMENTS = '/obligation_establishment/';
export const DELETE_OBLIGATION_ESTABLISHMENT = '/obligation_establishment';
export const ADD_OBLIGATION_ESTABLISHMENT = '/obligation_establishment/';
export const UPDATE_OBLIGATION_ESTABLISHMENT = '/obligation_establishment';
export const OBLIGATION_ESTABLISHMENTS_UPDATE = '/obligation_establishment/update';
export const OBLIGATION_ESTABLISHMENTS_CRITICALITY = '/obligation_establishment/criticality';
export const OBLIGATION_ESTABLISHMENTS_COMPLIANCE = '/obligation_establishment/compliance';
export const OBLIGATION_ESTABLISHMENTS_COMPLIANCE_MATRIX = '/obligation_establishment/compliance/matrix';

// Normative impact
export const IMPACT = '/impact';
export const GET_IMPACTS = '/impact/';
export const DELETE_IMPACT = '/impact';
export const ADD_IMPACT = '/impact/';
export const UPDATE_IMPACT = '/impact';

// Normative probability
export const PROBABILITY = '/probability';
export const GET_PROBABILITIES = '/probability/';
export const DELETE_PROBABILITY = '/probability';
export const ADD_PROBABILITY = '/probability/';
export const UPDATE_PROBABILITY = '/probability';

// Normative periodicity
export const PERIODICITY = '/periodicity';
export const PERIODICITY_BY_CODE = '/periodicity/code';
export const GET_PERIODICITIES = '/periodicity/';
export const DELETE_PERIODICITY = '/periodicity';
export const ADD_PERIODICITY = '/periodicity/';
export const UPDATE_PERIODICITY = '/periodicity';

// Normatives Establishment
export const NORMATIVE_ESTABLISHMENT = '/normative_establishment';
export const GET_NORMATIVE_ESTABLISHMENTS = '/normative_establishment/';
export const DELETE_NORMATIVE_ESTABLISHMENT = '/normative_establishment';
export const ADD_NORMATIVE_ESTABLISHMENT = '/normative_establishment/';
export const UPDATE_NORMATIVE_ESTABLISHMENT = '/normative_establishment';
export const NORMATIVE_ESTABLISHMENT_DETAIL = '/normative_establishment/detail';


// Article
export const ARTICLE = '/article';
export const GET_ARTICLE = '/article/';
export const DELETE_ARTICLE = '/article';
export const ADD_ARTICLE = '/article/';
export const UPDATE_ARTICLE = '/article';
export const ARTICLE_MULTIPLE = '/article/multiple/';

// Application Phase
export const APPLICATION_PHASE = '/application_phase';
export const GET_APPLICATION_PHASE = '/application_phase/';
export const DELETE_APPLICATION_PHASE = '/application_phase';
export const ADD_APPLICATION_PHASE = '/application_phase/';
export const UPDATE_APPLICATION_PHASE = '/application_phase';

// Environmental Component
export const ENVIRONMENTAL_COMPONENT = '/environmental_component';
export const GET_ENVIRONMENTAL_COMPONENT = '/environmental_component/';
export const DELETE_ENVIRONMENTAL_COMPONENT = '/environmental_component';
export const ADD_ENVIRONMENTAL_COMPONENT = '/environmental_component/';
export const UPDATE_ENVIRONMENTAL_COMPONENT = '/environmental_component';

// Relevant Aspect
export const RELEVANT_ASPECT = '/relevant_aspect';
export const GET_RELEVANT_ASPECT = '/relevant_aspect/';
export const DELETE_RELEVANT_ASPECT = '/relevant_aspect';
export const ADD_RELEVANT_ASPECT = '/relevant_aspect/';
export const UPDATE_RELEVANT_ASPECT = '/relevant_aspect';

// Supervisory Entity
export const SUPERVISORY_ENTITY = '/supervisory_entity';
export const GET_SUPERVISORY_ENTITY = '/supervisory_entity/';
export const DELETE_SUPERVISORY_ENTITY = '/supervisory_entity';
export const ADD_SUPERVISORY_ENTITY = '/supervisory_entity/';
export const UPDATE_SUPERVISORY_ENTITY = '/supervisory_entity';

// Evidence Type
export const EVIDENCE_TYPE = '/evidence_type';
export const GET_EVIDENCE_TYPE = '/evidence_type/';
export const DELETE_EVIDENCE_TYPE = '/evidence_type';
export const ADD_EVIDENCE_TYPE = '/evidence_type/';
export const UPDATE_EVIDENCE_TYPE = '/evidence_type';

// Evidence
export const EVIDENCE = '/evidence';
export const GET_EVIDENCE = '/evidence/';
export const DELETE_EVIDENCE = '/evidence';
export const ADD_EVIDENCE = '/evidence/';
export const UPDATE_EVIDENCE = '/evidence';
export const REVIEW_EVIDENCE = '/evidence';